import { render } from "./CorpDir.vue?vue&type=template&id=fc8f8b52&scoped=true"
import script from "./CorpDir.vue?vue&type=script&lang=js"
export * from "./CorpDir.vue?vue&type=script&lang=js"

import "./CorpDir.vue?vue&type=style&index=0&id=fc8f8b52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8f8b52"]])

export default __exports__